<div #destinationsContent
     class="destination-box__content"
     [class.destination-box__content--fixed-h]="plannerView === ETripPlannerView.CITY_OVERVIEW">
    <div cdkDropList
         cdkDropListLockAxis="y"
         cdkDropListAutoScrollStep="6"
         class="destinations-cards"
         (cdkDropListDropped)="drop($event)"
    >
        <span class="destinations-cards__dashes"></span>
        @if(isFetching) {
          @for (destination of [1, 2, 3, 4]; let idx = $index; let first = $first; let last = $last; track idx) {
            <div class="sr-only">
              <h2>About <ngx-skeleton-loader [theme]="{display: 'inline-block', margin: '0 0 0 7px', width: '40px', height: '10px'}"></ngx-skeleton-loader></h2>
              <ngx-skeleton-loader [theme]="{display: 'block', margin: '0 0 10px', width: '100%', height: '10px'}"></ngx-skeleton-loader>
              <ngx-skeleton-loader [theme]="{display: 'block', margin: '0 0 10px', width: '100%', height: '10px'}"></ngx-skeleton-loader>
              <ngx-skeleton-loader [theme]="{display: 'block', margin: '0', width: '100%', height: '10px'}"></ngx-skeleton-loader>
            </div>
            @if (breakpointService.isMobile()) {
              <li class="trip-destinations__item trip-destinations__item--fetching">
                <div class="trip-card">
                  <ngx-skeleton-loader [theme]="{display: 'block', margin: '0', width: '100%', height: '222px'}"></ngx-skeleton-loader>
                </div>
              </li>
            }
          }
        } @else {
          @for (destination of destinations; let idx = $index; let first = $first; let last = $last; track idx) {
            <div class="sr-only">
              <h2>About {{ destination.cityName }}</h2>
              @if (destination.shortDescription) {
                <p>{{ destination.description }}</p>
              }
              @if (destination.description) {
                <p [innerHTML]="destination.description  | safeHtml"></p>
              }
              @if (destination.extraDescription) {
                <p [innerHTML]="destination.extraDescription  | safeHtml"></p>
              }
            </div>
            @if (breakpointService.isMobile()) {
              <li cdkDrag
                  cdkDragBoundary=".mobile-planner__destinations-list"
                  class="trip-destinations__item"
              >
                <div class="trip-card" (click)="onSelectTrip.emit(idx)">
                  <div class="trip-card__top" [style.background-image]="'url(' + destination.imageUrl + ')'">
                    <button class="m-reorder" cdkDragHandle>
                      <img ngSrc="assets/used-icons/ic-reorder.svg" width="16" height="16" alt=""/>
                    </button>
                    <button class="m-menu" [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation(); $event.preventDefault()">
                      <img ngSrc="assets/used-icons/ic-horizontal-dots.svg" width="16" height="16" alt="">
                    </button>
                    <mat-menu #actionsMenu="matMenu" xPosition="before">
                      @if (!first && !last) {
                        <button mat-menu-item (click)="onChangeDestination(destination, idx)">
                          <img
                            class="m-item-icon"
                            ngSrc="assets/used-icons/ic-change-dest.svg"
                            width="16"
                            height="16"
                            alt="change"
                          />
                          Change destination
                        </button>
                        <button mat-menu-item (click)="onRemoveDestination(destination, idx)">
                          <img
                            class="m-item-icon"
                            ngSrc="assets/used-icons/ic-trash.svg"
                            width="16"
                            height="16"
                            alt="trash"
                          />
                          Remove from trip
                        </button>
                        <button mat-menu-item
                                (click)="onLockOrUnlockDestination.emit(destination)">
                          <img
                            [ngSrc]="'assets/used-icons/ic-' + (destination.locked ? 'lock-filled' : 'lock') + '.svg'"
                            class="m-item-icon"
                            width="16"
                            height="16"
                            alt="icon"
                          />
                          {{ destination.locked ? 'Unlock' : 'Lock' }} destination
                        </button>
                      }
                      <button mat-menu-item (click)="onSelectTrip.emit(idx)">
                        <img
                          class="m-item-icon"
                          ngSrc="assets/used-icons/ic-eye.svg"
                          width="16"
                          height="16"
                          alt="eye"
                        />
                        Open city services
                      </button>
                    </mat-menu>

                    <div class="main-info">
                      <p class="city-name">{{ destination.cityName }}</p>
                    </div>
                  </div>
                  <div class="trip-card__content">
                    <div class="main-info">
                      @if (isSpecifyDates) {
                        <p class="dates-text">
                          {{ (destination.dates.from | date: 'mediumDate') + ' - ' + (destination.dates.to | date: 'mediumDate') }}
                        </p>
                      }
                    </div>
                    <div class="nights-box">
                      <button mat-ripple [disabled]="destination.days < 2">
                        <mat-icon
                          [svgIcon]="ESvgIcons.IC_MINUS"
                          (click)="toggleNightsChange(-1, destination, $event)"
                        ></mat-icon>
                      </button>
                      <span><b>{{ destination.days }}</b> nights</span>
                      <button mat-ripple [disabled]="destination.days >= 10">
                        <mat-icon
                          [svgIcon]="ESvgIcons.IC_PLUS"
                          (click)="toggleNightsChange(+1, destination, $event)"
                        ></mat-icon>
                      </button>
                    </div>
                  </div>
                  <div class="trip-card__bottom">
                    <button (click)="handleScrollTo($event, '1')">
                      @if ((destination.favorites | getFavoritesByProvider: 'booking.com').length; as hotels) {
                        <span class="badge">{{ hotels }}</span>
                      }
                      Hotels
                    </button>
                    <span class="vl-separator"></span>
                    <button (click)="handleScrollTo($event, '2')">
                      @if ((destination.favorites | getFavoritesByProvider: 'viator').length; as viators) {
                        <span class="badge">{{ viators }}</span>
                      }
                      Activities
                    </button>
                    <span class="vl-separator"></span>
                    <button (click)="handleScrollTo($event, '3')">
                      @if ((destination.favorites | getFavoritesByProvider: 'occasion_genius').length; as events) {
                        <span class="badge">{{ events }}</span>
                      }
                      Events
                    </button>
                  </div>
                </div>
              </li>
            } @else {
              <div cdkDrag
                   cdkDragBoundary=".destination-box__content"
                   [cdkDragScale]="generalZoomLevel"
                   class="destinations-cards__item"
                   [class.destinations-cards__item--small]="plannerView !== ETripPlannerView.PLANNER_OVERVIEW"
              >
                <div class="item-pin" [style.--pin-color]="PIN_COLORS[idx]">
                  <button class="item-pin__index" (click)="onSelectTrip.emit(idx)">{{ idx + 1 }}</button>
                </div>
                <div class="item-card" [class.active]="idx === cityInfoIndex" (click)="onSelectTrip.emit(idx)">
                  <div class="item-card__re-order" cdkDragHandle (click)="$event.stopPropagation()">
                    <img ngSrc="assets/svg/ic-drag.svg" width="24" height="24" alt="re-order">
                  </div>
                  <div class="item-card__info">
                    <p class="city-name">{{ destination.cityName }}</p>
                    <p class="city-place">
                      {{ (destination.region ? destination.region + ', ' : '') + destination.countryName }}
                    </p>
                  </div>
                  <div class="item-card__actions">
                    <div class="lock-button">
                      <button
                        mat-icon-button
                        (click)="$event.stopPropagation(); onLockOrUnlockDestination.emit(destination)"
                        [disabled]="first || last">
                        <mat-icon
                          [svgIcon]="(first || last || destination.locked ? ESvgIcons.LOCKED : ESvgIcons.UNLOCKED)"
                        ></mat-icon>
                      </button>
                    </div>

                    <div class="absolute-box">
                      <div class="absolute-box__menu">
                        <button mat-icon-button [matMenuTriggerFor]="actionsMenu"
                                (click)="$event.stopPropagation()">
                          <mat-icon [svgIcon]="ESvgIcons.MENU_DOTS_HOR"></mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" xPosition="before">
                          @if (!first && !last) {
                            <button mat-menu-item (click)="onChangeDestination(destination, idx)">
                              <img
                                class="m-item-icon"
                                ngSrc="assets/used-icons/ic-change-dest.svg"
                                width="16"
                                height="16"
                                alt="change"
                              />
                              Change destination
                            </button>
                            <button mat-menu-item (click)="onRemoveDestination(destination, idx)">
                              <img
                                class="m-item-icon"
                                ngSrc="assets/used-icons/ic-trash.svg"
                                width="16"
                                height="16"
                                alt="trash"
                              />
                              Remove from trip
                            </button>
                            <button mat-menu-item
                                    (click)="onLockOrUnlockDestination.emit(destination)">
                              <img
                                [ngSrc]="'assets/used-icons/ic-' + (destination.locked ? 'lock-filled' : 'lock') + '.svg'"
                                class="m-item-icon"
                                width="16"
                                height="16"
                                alt="icon"
                              />
                              {{ destination.locked ? 'Unlock' : 'Lock' }} destination
                            </button>
                          }
                          <button mat-menu-item (click)="onSelectTrip.emit(idx)">
                            <img
                              class="m-item-icon"
                              ngSrc="assets/used-icons/ic-eye.svg"
                              width="16"
                              height="16"
                              alt="eye"
                            />
                            Open city services
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                    <div class="nights-box">
                      <button class="night-control"
                              (click)="$event.stopPropagation(); nightsControlRef.open()">
                        <span>{{ setNightsString(destination.days) }}</span>
                        <mat-select
                          #nightsControlRef
                          class="hidden-select"
                          [value]="destination.days - 1"
                          (selectionChange)="onChangeNightsOfDestination($event.value, destination, $event.source)"
                        >
                          @for (night of NIGHTS; track $index) {
                            <mat-option class="initial-space" [value]="night.value - 1">
                              {{ night.text }}
                            </mat-option>
                          }
                        </mat-select>
                      </button>
                    </div>
                    @if (isSpecifyDates) {
                      <p class="duration">
                        {{ (destination.dates.from | date: 'mediumDate') + ' - ' + (destination.dates.to | date: 'mediumDate') }}
                      </p>
                    }
                  </div>
                </div>
              </div>
            }
            @if (!last) {
              <div class="destinations-cards__en-route">
                <div class="en-route-icon" [class.en-route-icon--active]="selectedStopoversBoxIndex === idx">
                  <img ngSrc="assets/svg/ic-en-route-w.svg" width="28" height="26" alt="en route icon">
                </div>
                <div class="en-route-duration">
                  <p class="en-route-duration__text">
                    @if (destination.stopovers.length) {
                      <span class="en-route-duration__info" (click)="selectStopoversBoxIndex(idx); handleScrollTo($event, '5')"> Sights on the way</span>
                    }
                    @if (legs.length && legs[idx]; as leg) {
                      @if ([leg.time, leg.dist].includes('N/A')) {
                        <span style="display:flex; align-content: center">
                                  <ngx-skeleton-loader [theme]="{
                                    height: '12px',
                                    width: '30px',
                                    margin: '0 5px 0 0'
                                  }"></ngx-skeleton-loader>
                                  <span> | </span>
                                  <ngx-skeleton-loader [theme]="{
                                    height: '12px',
                                    width: '30px',
                                    margin: '0 0 0 5px'
                                  }"></ngx-skeleton-loader>
                                </span>
                      } @else {
                        <span> {{ leg.dist + ' | ' + leg.time }} </span>
                      }
                    }
                  </p>
                  @if (selectedStopoversBoxIndex === idx) {
                    <div class="en-routes">
                      @for (stopover of destination.stopovers | slice: 0 : 5; track $index) {
                        <div class="en-routes__item">
                          <div class="en-route-img"
                               [style.background-image]="'url(' + stopover.imageUrl + ')'"></div>
                          <div class="en-route-text">
                            <p class="en-route-text__name">{{ stopover.name }}</p>
                            <p class="en-route-text__region">
                              {{ destination.countryName + (destination.region ? ', ' + destination.region + ' region' : '') }}
                            </p>
                          </div>
                        </div>
                      }
                      @if (destination.stopovers.length > 5) {
                        <p class="en-routes__show-more">See all en-route</p>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          }
        }
    </div>
</div>


<div class="destination-box__bottom">
    @if (plannerView === ETripPlannerView.PLANNER_OVERVIEW && destinations.length > 4) {
        <span class="expand-dot"></span>
        <p class="expand-text" (click)="toggleExpand.emit()">
            {{hasScroll(destinationsContent) ? 'Expand' : 'Minimize'}}
        </p>
    }
    @if (trip().blogUrl) {
        <button mat-ripple (click)="onOpenDBDTripBlog()">Day by day</button>
    }
</div>
